import { render } from "./NewChatForm.vue?vue&type=template&id=4e36511a&scoped=true"
import script from "./NewChatForm.vue?vue&type=script&lang=js"
export * from "./NewChatForm.vue?vue&type=script&lang=js"

import "./NewChatForm.vue?vue&type=style&index=0&id=4e36511a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4e36511a"

export default script